import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Navbar - A className-based implementation that matches the Bulma Navbar
 * 
 * This component provides the same API as Bloomer's Navbar for easy migration
 */
const Navbar = ({
  children,
  className,
  isTransparent,
  isFixedTop,
  isFixedBottom,
  hasShadow,
  isPrimary,
  isInfo,
  isSuccess,
  isWarning,
  isDanger,
  isLight,
  isDark,
  isBlack,
  isWhite,
  ...rest
}) => {
  const navbarClasses = classNames('navbar', {
    'is-transparent': isTransparent,
    'is-fixed-top': isFixedTop,
    'is-fixed-bottom': isFixedBottom,
    'has-shadow': hasShadow,
    'is-primary': isPrimary,
    'is-info': isInfo,
    'is-success': isSuccess,
    'is-warning': isWarning,
    'is-danger': isDanger,
    'is-light': isLight,
    'is-dark': isDark,
    'is-black': isBlack,
    'is-white': isWhite,
    [className]: className,
  });

  return (
    <nav className={navbarClasses} role="navigation" aria-label="main navigation" {...rest}>
      {children}
    </nav>
  );
};

Navbar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isTransparent: PropTypes.bool,
  isFixedTop: PropTypes.bool,
  isFixedBottom: PropTypes.bool,
  hasShadow: PropTypes.bool,
  isPrimary: PropTypes.bool,
  isInfo: PropTypes.bool,
  isSuccess: PropTypes.bool,
  isWarning: PropTypes.bool,
  isDanger: PropTypes.bool,
  isLight: PropTypes.bool,
  isDark: PropTypes.bool,
  isBlack: PropTypes.bool,
  isWhite: PropTypes.bool,
};

Navbar.defaultProps = {
  children: null,
  className: '',
  isTransparent: false,
  isFixedTop: false,
  isFixedBottom: false,
  hasShadow: false,
  isPrimary: false,
  isInfo: false,
  isSuccess: false,
  isWarning: false,
  isDanger: false,
  isLight: false,
  isDark: false,
  isBlack: false,
  isWhite: false,
};

export default Navbar;
